import type { ApprovalState } from "@zworks/console-contracts";
import { StatusBadge } from "@/components/bespoke/status-badge";

/** A labelled approval-state badge using the shared StatusBadge component. */
export function ApprovalStateBadge({ state }: { state: ApprovalState }) {
  return <StatusBadge kind="approval" status={state} />;
}
